var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"home-rigth-fixbox"},[_c('el-image',{staticStyle:{"width":"80px","height":"76px","cursor":"pointer"},attrs:{"src":_vm.arrowsUrl},on:{"click":_vm.returnTopFn}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }